import './SessaoPrincipal.css';
import { useEffect } from "react";

function SessaoPrincipal() {
    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add("fade-in");
                }
            });
        }, { threshold: 0.1 });

        // Observamos os títulos, descrição e botão de link
        document.querySelectorAll(".inicio-titulo, .descricao, .button").forEach((el) => observer.observe(el));

        return () => observer.disconnect();
    }, []);

    return (
        <div className="container-inicial container-principal">
            <div className="text">
                <h1 className="inicio-titulo">Blue Análises e Serviços Ambientais</h1>
                <h5 className="inicio-titulo">Soluções Ambientais e Consultorias</h5>
                <p className="descricao">Oferecemos consultoria especializada para empresas e instituições que buscam atuar de maneira sustentável, garantindo conformidade legal e eficiência operacional. Com abordagem personalizada e excelência técnica, ajudamos nossos clientes a transformar desafios ambientais em oportunidades de inovação e crescimento sustentável.</p>
                <a
                    href="https://wa.me/553233210063?text=Olá%2C%20vim%20pelo%20site%20e%20quero%20saber%20mais%20informações%20sobre%20os%20serviços%20da%20Blue%20Análises%20e%20Serviços%20Ambientais."
                    id="cp-btn"
                    className="button"
                    aria-label="Entrar em contato pelo WhatsApp para saber mais sobre serviços ambientais"
                >
                    Saiba mais
                </a>
            </div>
        </div>


    );
}

export default SessaoPrincipal;